export const RULE_TYPE_OPTIONS = [
    { label: "SMS OTP", value: "SMS_OTP" },
    { label: "Facial Check", value: "FACIAL_CHECK" },
    { label: "Transfer Time Check", value: "TRANSFER_TIME_CHECK" },
    { label: "Admin Approval", value: "ADMIN_APPROVAL" },
  ];
  
  // Swagger only shows "BOOLEAN" as an example value — STRING/NUMBER are a
  // reasonable guess for a generic config table, but unconfirmed. Trim/extend
  // once backend confirms the full valueType enum.
  export const CONFIG_VALUE_TYPE_OPTIONS = [
    { label: "Boolean", value: "BOOLEAN" },
    { label: "String", value: "STRING" },
    { label: "Number", value: "NUMBER" },
  ];